/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

import { PunchContainer, Styles } from './CreateSchedules.Style';
import { useTranslation } from 'react-i18next';
import theme from '../../../../../Shared/Themes/theme';
import { IPunchInOutGracePeriodProps } from './CreateSchedule.Model';

const PunchInOutGracePeriod: React.FC<IPunchInOutGracePeriodProps> = ({
  punchInHours,
  setPunchInHours,
  punchInMinutes,
  setPunchInMinutes,
  punchOutHours,
  setPunchOutHours,
  punchOutMinutes,
  setPunchOutMinutes,
}) => {
  const { t } = useTranslation(['jobManagement']);

  const { marginBottom } = Styles;

  return (
    <PunchContainer sx={{ marginBottom: marginBottom.marginBottom }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ fontWeight: 500, marginBottom: '1rem' }}>{t('jobManagement:punchInGraceTime')}</Typography>

        <Box display="flex" gap={2} alignItems="center">
          <TextField
            type="number"
            inputProps={{ min: 0, max: 23 }}
            value={punchInHours}
            onChange={(e) => {
              const value = e?.target?.value;
              const parsedValue = value ? parseInt(value, 10) : undefined;

              if (parsedValue === undefined || (parsedValue >= 0 && parsedValue <= 23)) {
                setPunchInHours(parsedValue);
              }
            }}
            sx={{
              '& .MuiInputBase-root': {
                borderRadius: '1rem',
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset,&:hover fieldset,&.Mui-focused fieldset': {
                  borderWidth: 1,
                  borderColor: theme.palette.secondary.light,
                  borderRadius: '1rem',
                },
              },
            }}
          />
          <Typography>{t('jobManagement:hrs')}</Typography>

          <TextField
            type="number"
            inputProps={{ min: 0, max: 59 }}
            value={punchInMinutes}
            onChange={(e) => {
              const value = e?.target?.value;
              const parsedValue = value ? parseInt(value, 10) : undefined;
              if (parsedValue === undefined || (parsedValue >= 0 && parsedValue <= 59)) {
                setPunchInMinutes(parsedValue);
              }
            }}
            sx={{
              '& .MuiInputBase-root': {
                borderRadius: '1rem',
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset,&:hover fieldset,&.Mui-focused fieldset': {
                  borderWidth: 1,
                  borderColor: theme.palette.secondary.light,
                  borderRadius: '1rem',
                },
              },
            }}
          />
          <Typography>{t('jobManagement:mins')}</Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ fontWeight: 500, marginBottom: '1rem' }}>{t('jobManagement:punchOutGraceTime')}</Typography>

        <Box display="flex" gap={2} alignItems="center">
          <TextField
            type="number"
            inputProps={{ min: 0, max: 24 }}
            value={punchOutHours}
            onChange={(e) => {
              const value = e.target.value;
              const parsedValue = value ? parseInt(value, 10) : undefined;

              if (parsedValue === undefined || (parsedValue >= 0 && parsedValue <= 23)) {
                setPunchOutHours(parsedValue);
              }
            }}
            sx={{
              '& .MuiInputBase-root': {
                borderRadius: '1rem',
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset,&:hover fieldset,&.Mui-focused fieldset': {
                  borderWidth: 1,
                  borderColor: theme.palette.secondary.light,
                  borderRadius: '1rem',
                },
              },
            }}
          />
          <Typography>{t('jobManagement:hrs')}</Typography>

          <TextField
            type="number"
            inputProps={{ min: 0, max: 59 }}
            value={punchOutMinutes}
            onChange={(e) => {
              const value = e.target.value;
              const parsedValue = value ? parseInt(value, 10) : undefined;

              if (parsedValue === undefined || (parsedValue >= 0 && parsedValue <= 59)) {
                setPunchOutMinutes(parsedValue);
              }
            }}
            sx={{
              '& .MuiInputBase-root': {
                borderRadius: '1rem',
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset,&:hover fieldset,&.Mui-focused fieldset': {
                  borderWidth: 1,
                  borderColor: theme.palette.secondary.light,
                  borderRadius: '1rem',
                },
              },
            }}
          />
          <Typography>{t('jobManagement:mins')}</Typography>
        </Box>
      </Box>
    </PunchContainer>
  );
};

export default PunchInOutGracePeriod;
